const { getOffsetTop } = window.BAO.Utils

class OverlayText extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setScrollDistance()
  }

  setScrollDistance () {
    if (!this.els.media?.exists) return

    const maxDistance =
      this.els.media.element.scrollWidth - this.els.media.element.offsetWidth

    const elementStartPoint =
      getOffsetTop(this.els.media.element) + 200 - window.innerHeight
    const elementEndPoint =
      getOffsetTop(this.els.media.element) +
      this.els.media.element.offsetHeight -
      200

    if (this.lastKnownY <= elementStartPoint) {
      this.els.media.element.style.setProperty('--Transform_Amount', `0px`)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.els.media.element.style.setProperty(
        '--Transform_Amount',
        `-${maxDistance}px`,
      )

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformDistance = 1 - maxDistance * scrollYAsAPercentageOfJourney

    this.els.media.element.style.setProperty(
      '--Transform_Amount',
      `${transformDistance}px`,
    )
  }
}

if (!customElements.get('overlay-text')) {
  customElements.define('overlay-text', OverlayText)
}
